'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002426 from "./presto.-Agent-View$$anon$26.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
import * as $j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024 from "./presto.types$proto$-Unsigned-File-Base64$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$25() {
  this.ayC = null;
  this.ayu = null;
  this.ayv = false;
  this.ayD = null;
  this.ayE = false;
  this.ayH = null;
  this.ayA = null;
  this.ayB = false;
  this.ayw = null;
  this.ayx = false;
  this.ayy = null;
  this.ayz = false;
  this.ayF = false;
  this.ayG = false;
  this.ayC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ayH = "UnsignedFileBase64";
}
export { $c_Lpresto_AgentView$$anon$25 as $c_Lpresto_AgentView$$anon$25 };
$p = $c_Lpresto_AgentView$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$25;
/** @constructor */
function $h_Lpresto_AgentView$$anon$25() {
}
export { $h_Lpresto_AgentView$$anon$25 as $h_Lpresto_AgentView$$anon$25 };
$h_Lpresto_AgentView$$anon$25.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.ayC;
});
$p.M = (function() {
  if ((!this.ayv)) {
    this.ayu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ayv = true;
  }
  return this.ayu;
});
$p.O = (function() {
  if ((!this.ayE)) {
    this.ayD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ayE = true;
  }
  return this.ayD;
});
$p.D = (function() {
  return this.ayH;
});
$p.t = (function() {
  if ((!this.ayB)) {
    this.ayA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayB = true;
  }
  return this.ayA;
});
$p.N = (function() {
  if ((!this.ayx)) {
    this.ayw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a34(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().ra(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayx = true;
  }
  return this.ayw;
});
$p.Q = (function() {
  if ((!this.ayz)) {
    this.ayy = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002426.$c_Lpresto_AgentView$$anon$26();
    this.ayz = true;
  }
  return this.ayy;
});
$p.v = (function() {
  if ((!this.ayG)) {
    this.ayF = false;
    this.ayG = true;
  }
  return this.ayF;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee176) => ((p) => \u03b4scrutinee176.cI4(p)))($j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024.$m_Lpresto_types$proto$UnsignedFileBase64$())));
});
var $d_Lpresto_AgentView$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$25, "presto.AgentView$$anon$25", ({
  DU: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$25 as $d_Lpresto_AgentView$$anon$25 };
//# sourceMappingURL=presto.-Agent-View$$anon$25.js.map
